module.exports = __webpack_public_path__ + "static/media/w.9a6f2382.svg";